/**
 * This defines the exact routes for easier later use
 * when creating a new route remember to both to define it here, and
 * add it later to the RosebudRoutesSettings array
 */
export enum AgentRoute {
  Welcome = "start",
  AgeAndGender = "age",
  ChiefComplaint = "chiefComplaint",
  Background = "background",
  ClinicalFeatures = "clinicalFeatures",
  Workup = "workup",
  PhyscialExamination = "physicalExamination",
  ReviewOfSystems = "reviewOfSystems",
  EditBackground = "editBackground",
  EditPanel = "editPanel",
  EditClinicalFeatures = "editClinicalFeatures",
  EditWorkup = "editWorkup",
  Edit = "edit",
  VitalSigns = "vitalSigns",
  DataEntry = "dataEntry",
  DD = "dd",
  Cases = "cases",
  ExpandedDisease = "expandedDisease",
  Expanded = "expanded",
  Graph = "graph",
  Resources = "resources",
  PatientChart = "patientChart",
  RecommendedPlan = "recommendedPlan",
  HistoryAndPhysical = "historyAndPhysical",
  Export = "export",
  TermsOfService = "termsofservice",
  Login = "login",
  Signup = "signup",
  PasswordReset = "newPassword",
  PatientFirstSummary = "patientFirstSummary",
}
